const musicLinksValidationNL = {
    "add": {
        "release_name": {
            "required": "Release Naam is vereist"
        },
        "ean": {
            "required": "EAN/UPC is vereist"
        },
        "artist_name": {
            "required": "Artiest Naam is vereist"
        },
        "url_part1": {
            "required": "Url Deel 1 is vereist"
        },
        "url_part2": {
            "required": "Url Deel 2 is vereist",
            "length": "Url Deel 2 mag niet langer zijn dan 10 tekens",
            "duplicate": "Oeps! Deze url is al gekoppeld aan een andere muzieklink. Probeer een andere url.",
            "urlAvailable": "Url is beschikbaar",
            "urlInvalid": "Url is ongeldig"
        },
        "amazonmusic_url": {
            "required": "Amazon Music Url is vereist",
            "invalid": "Voeg een geldige Amazon Music Url toe."
        },
        "applemusic_url": {
            "required": "Apple Music Url is vereist",
            "invalid": "Voeg een geldige Apple Music Url toe."
        },
        "beatport_url": {
            "required": "Beatport Url is vereist",
            "invalid": "Voeg een geldige Beatport Url toe."
        },
        "deezer_url": {
            "required": "Deezer Url is vereist",
            "invalid": "Voeg een geldige Deezer Url toe."
        },
        "junodownload_url": {
            "required": "Junodownload Url is vereist",
            "invalid": "Voeg een geldige Junodownload Url toe."
        },
        "soundcloud_url": {
            "required": "Soundcloud Url is vereist",
            "invalid": "Voeg een geldige Soundcloud Url toe."
        },
        "spotify_url": {
            "required": "Spotify Url is vereist",
            "invalid": "Voeg een geldige Spotify Url toe."
        },
        "tidal_url": {
            "required": "Tidal Url is vereist",
            "invalid": "Voeg een geldige Tidal Url toe."
        },
        "traxsource_url": {
            "required": "Traxsource Url is vereist",
            "invalid": "Voeg een geldige Traxsource Url toe."
        },
        "youtube_url": {
            "required": "Youtube Url is vereist",
            "invalid": "Voeg een geldige Youtube Url toe."
        },
        "anghami_url": {
            "required": "Anghami Url is vereist",
            "invalid": "Voeg een geldige Url toe."
        },
        "bandcamp_url": {
            "required": "Bandcamp Url is vereist",
            "invalid": "Voeg een geldige Url toe."
        },
        "boomplay_url": {
            "required": "Boomplay Url is vereist",
            "invalid": "Voeg een geldige Url toe."
        },
        "iheartradio_url": {
            "required": "iHeartRadio Url is vereist",
            "invalid": "Voeg een geldige Url toe."
        },
        "jiosaavn_url": {
            "required": "JioSaavn Url is vereist",
            "invalid": "Voeg een geldige Url toe."
        },
        "sevendigital_url": {
            "required": "7digital Url is vereist",
            "invalid": "Voeg een geldige Url toe."
        },
        "other_url": {
            "invalid": "Voeg een geldige Url toe."
        },
        "pvTrackName": {
            "required": "Track Naam is vereist"
        },
        "pvArtistName": {
            "required": "Artiest Naam is vereist"
        }
    },
    "update": {
        "release_name": {
            "required": "Release Naam is vereist"
        },
        "ean": {
            "required": "EAN/UPC is vereist"
        },
        "artist_name": {
            "required": "Artiest Naam is vereist"
        },
        "url_part1": {
            "required": "Url Deel 1 is vereist"
        },
        "url_part2": {
            "required": "Url Deel 2 is vereist",
            "length": "Url Deel 2 mag niet langer zijn dan 10 tekens",
            "duplicate": "Oeps! Deze url is al gekoppeld aan een andere muzieklink. Probeer een andere url.",
            "urlAvailable": "Url is beschikbaar",
            "urlInvalid": "Url is ongeldig"
        },
        "amazonmusic_url": {
            "required": "Amazon Music Url is vereist",
            "invalid": "Voeg een geldige Amazon Music Url toe."
        },
        "applemusic_url": {
            "required": "Apple Music Url is vereist",
            "invalid": "Voeg een geldige Apple Music Url toe."
        },
        "beatport_url": {
            "required": "Beatport Url is vereist",
            "invalid": "Voeg een geldige Beatport Url toe."
        },
        "deezer_url": {
            "required": "Deezer Url is vereist",
            "invalid": "Voeg een geldige Deezer Url toe."
        },
        "junodownload_url": {
            "required": "Junodownload Url is vereist",
            "invalid": "Voeg een geldige Junodownload Url toe."
        },
        "soundcloud_url": {
            "required": "Soundcloud Url is vereist",
            "invalid": "Voeg een geldige Soundcloud Url toe."
        },
        "spotify_url": {
            "required": "Spotify Url is vereist",
            "invalid": "Voeg een geldige Spotify Url toe."
        },
        "tidal_url": {
            "required": "Tidal Url is vereist",
            "invalid": "Voeg een geldige Tidal Url toe."
        },
        "traxsource_url": {
            "required": "Traxsource Url is vereist",
            "invalid": "Voeg een geldige Traxsource Url toe."
        },
        "youtube_url": {
            "required": "Youtube Url is vereist",
            "invalid": "Voeg een geldige Youtube Url toe."
        },
        "anghami_url": {
            "required": "Anghami Url is vereist",
            "invalid": "Voeg een geldige Url toe."
        },
        "bandcamp_url": {
            "required": "Bandcamp Url is vereist",
            "invalid": "Voeg een geldige Url toe."
        },
        "boomplay_url": {
            "required": "Boomplay Url is vereist",
            "invalid": "Voeg een geldige Url toe."
        },
        "iheartradio_url": {
            "required": "iHeartRadio Url is vereist",
            "invalid": "Voeg een geldige Url toe."
        },
        "jiosaavn_url": {
            "required": "JioSaavn Url is vereist",
            "invalid": "Voeg een geldige Url toe."
        },
        "sevendigital_url": {
            "required": "7digital Url is vereist",
            "invalid": "Voeg een geldige Url toe."
        },
        "other_url": {
            "invalid": "Voeg een geldige Url toe."
        },
        "pvTrackName": {
            "required": "Track Naam is vereist"
        },
        "pvArtistName": {
            "required": "Artiest Naam is vereist"
        }
    }
};

export default musicLinksValidationNL;